import React from 'react';
import { Link } from 'react-router-dom';
import { companyInfo } from '../data';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  const usefulLinks = [
    { label: 'Cacao ceremoni', path: '/events' },
    { label: 'Rosen ceremoni', path: '/events' },
    { label: 'Blomstringsfrekvens', path: '/events' },
    { label: 'Oprindelsens lys', path: '/events' },
    { label: 'Kvindekraft', path: '/events' }
  ];

  const practicalInfo = [
    { label: 'Event kalender', path: '/events' },
    { label: 'Facebook gruppe', href: companyInfo.facebookGroup },
    { label: 'Om mig', path: '/om-johanne' },
    { label: 'Kontakt', path: '/kontakt' }
  ];

  return (
    <footer className="bg-[#1B2234] text-white pt-16 pb-10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Centered Logo above the footer columns */}
        <div className="flex justify-center mb-12">
          <Link to="/" className="inline-block group text-center">
            <img 
              src="https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=95,format=auto/assets/9c094138-0bed-486b-b914-79750263377d/johanne-eis-logo-sand.webp" 
              alt="Johanne Eis Logo" 
              className="w-full max-w-[260px] sm:max-w-[300px] h-auto object-contain mx-auto transition-transform duration-300 group-hover:scale-[1.02]"
              onError={(e) => {
                e.target.style.display = 'none';
                const fb = document.getElementById('footer-text-logo');
                if (fb) fb.style.display = 'block';
              }}
            />
            <span 
              id="footer-text-logo" 
              className="hidden font-display text-2xl tracking-wider text-white font-semibold transition-colors duration-300 group-hover:text-[#D7D0C6]"
            >
              Johanne Eis
            </span>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-10 lg:gap-8 mb-16 items-start">
          {/* Brand & Intro (spans 4 of 12 columns on desktop) */}
          <div className="lg:col-span-4 space-y-4">
            <h4 className="font-display text-xs uppercase tracking-widest text-slate-200 font-semibold mb-5 pb-2 border-b border-slate-800/80">
              Om Johanne Eis
            </h4>
            <div className="text-slate-300 text-sm leading-relaxed font-sans space-y-2 max-w-sm">
              <p className="font-normal text-slate-200">Spirituel livsskabelse med Sjælen som vejviser.</p>
              <p>Jeg skaber rum til fordybelse til dig i dit lys.</p>
              <p className="text-slate-400 text-xs sm:text-sm pt-1">
                Gennem ceremonier og levende nærvær åbnes et felt, hvor den ægte, sande dig får plads. Hvor du møder dig selv fra sjæl i sandhed, med blidhed og samtidig enorm kraftfuld styrke.
              </p>
            </div>

            <div className="flex items-center gap-3 pt-2">
              <a 
                href={companyInfo.facebookPage} 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-9 h-9 rounded-full bg-slate-800/80 border border-slate-700/80 flex items-center justify-center text-slate-200 hover:bg-[#D7D0C6] hover:text-[#1B2234] hover:border-[#D7D0C6] transition-all duration-300"
                aria-label="Besøg os på Facebook"
              >
                <i className="fa-brands fa-facebook-f text-xs" />
              </a>
              <a 
                href={companyInfo.instagram} 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-9 h-9 rounded-full bg-slate-800/80 border border-slate-700/80 flex items-center justify-center text-slate-200 hover:bg-[#D7D0C6] hover:text-[#1B2234] hover:border-[#D7D0C6] transition-all duration-300"
                aria-label="Besøg os på Instagram"
              >
                <i className="fa-brands fa-instagram text-xs" />
              </a>
            </div>
          </div>

          {/* Useful Links (spans 3 of 12 columns) */}
          <div className="lg:col-span-3 space-y-4">
            <h4 className="font-display text-xs uppercase tracking-widest text-slate-200 font-semibold mb-5 pb-2 border-b border-slate-800/80">
              Ceremonier & Cirkler
            </h4>
            <ul className="space-y-3">
              {usefulLinks.map((link, idx) => (
                <li key={idx}>
                  <Link 
                    to={link.path} 
                    className="text-slate-300 hover:text-[#D7D0C6] text-sm transition-all duration-200 font-sans inline-flex items-center gap-1.5 hover:translate-x-1"
                  >
                    <span>{link.label}</span>
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Practical Info (spans 2 of 12 columns) */}
          <div className="lg:col-span-2 space-y-4">
            <h4 className="font-display text-xs uppercase tracking-widest text-slate-200 font-semibold mb-5 pb-2 border-b border-slate-800/80">
              Praktisk info
            </h4>
            <ul className="space-y-3">
              {practicalInfo.map((link, idx) => (
                <li key={idx}>
                  {link.href ? (
                    <a 
                      href={link.href} 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="text-slate-300 hover:text-[#D7D0C6] text-sm transition-all duration-200 font-sans inline-flex items-center gap-1.5 hover:translate-x-1"
                    >
                      <span>{link.label}</span>
                    </a>
                  ) : (
                    <Link 
                      to={link.path} 
                      className="text-slate-300 hover:text-[#D7D0C6] text-sm transition-all duration-200 font-sans inline-flex items-center gap-1.5 hover:translate-x-1"
                    >
                      <span>{link.label}</span>
                    </Link>
                  )}
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info (spans 3 of 12 columns) */}
          <div className="lg:col-span-3 space-y-4">
            <h4 className="font-display text-xs uppercase tracking-widest text-slate-200 font-semibold mb-5 pb-2 border-b border-slate-800/80">
              Kontakt
            </h4>
            <div className="space-y-3 text-sm text-slate-300 font-sans">
              <p className="flex items-start gap-3">
                <i className="fa-light fa-location-dot text-[#D7D0C6] mt-1 text-sm shrink-0" />
                <span className="leading-snug">{companyInfo.address}</span>
              </p>
              <p className="flex items-center gap-3">
                <i className="fa-light fa-phone text-[#D7D0C6] text-sm shrink-0" />
                <a href={`tel:${companyInfo.phone.replace(/\s+/g, '')}`} className="hover:text-[#D7D0C6] transition-colors duration-200 whitespace-nowrap">
                  {companyInfo.phone}
                </a>
              </p>
              <p className="flex items-center gap-3">
                <i className="fa-light fa-envelope text-[#D7D0C6] text-sm shrink-0" />
                <a href={`mailto:${companyInfo.email}`} className="hover:text-[#D7D0C6] transition-colors duration-200 break-all sm:break-normal">
                  {companyInfo.email}
                </a>
              </p>
              <p className="text-xs text-slate-400/80 pt-2 border-t border-slate-800/60 mt-3">
                CVR: {companyInfo.cvr}
              </p>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-slate-800/90 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4 text-xs text-slate-400 font-sans">
          <p>© {currentYear} Johanne Eis. Alle rettigheder forbeholdes.</p>
          <p className="flex gap-4">
            <span>Webløsning af AP3</span>
          </p>
        </div>
      </div>
    </footer>
  );
}
